var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.proxyValue,
              expression: "proxyValue",
            },
          ],
          staticClass: "hkl-input-box",
          attrs: { type: "text" },
          domProps: { value: _vm.proxyValue },
          on: {
            change: function (e) {
              return _vm.onChange(e.target.value)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.proxyValue = $event.target.value
            },
          },
        },
        "input",
        _vm.$attrs,
        false
      ),
      _vm.proxyListeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }